export class FocusTrap {
    constructor(element, options) {
        this.focusableContent = [];
        this.eventListener = (event) => this.checkTrap(event);
        this.element = element;
        this.focusableElements =
            options ||
                "button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])";
    }
    refreshTrap(context) {
        this.findFocusableElements(context);
        if (this.firstFocusableElement) {
            this.firstFocusableElement.focus();
        }
    }
    toggleTrap(state, context) {
        if (state) {
            this.findFocusableElements(context);
            context.addEventListener('keydown', this.eventListener, true);
        }
        else {
            context.removeEventListener('keydown', this.eventListener, true);
        }
        if (this.firstFocusableElement) {
            this.firstFocusableElement.focus();
        }
    }
    findFocusableElements(element) {
        this.focusableContent = Array.from(element.querySelectorAll(this.focusableElements));
        this.firstFocusableElement = this.focusableContent[0];
        this.lastFocusableElement = (this.focusableContent[this.focusableContent.length - 1]);
    }
    checkTrap(event) {
        const eventKey = event;
        const isTabPressed = eventKey.key === 'Tab' || parseInt(eventKey.code, 10) === 9;
        if (!isTabPressed) {
            return;
        }
        if (eventKey.shiftKey) {
            if (document.activeElement === this.firstFocusableElement) {
                this.lastFocusableElement.focus();
                eventKey.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableElement) {
                this.firstFocusableElement.focus();
                eventKey.preventDefault();
            }
        }
    }
}
